import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DynamicHooksModule, HookParserEntry } from 'ngx-dynamic-hooks';
import { ArrayFilterPipe } from './array-filter.pipe';
import { CompareValueService } from './compare-value.service';
import { CourseCacheService } from './course-cache.service';
import { CourseChangeLogService } from './course-change-log.service';
import { CourseService } from './course.service';
import { FilterPipe } from './filter.pipe';
import { GradeStatementService } from './grade-statement.service';
import { GradingRuleService } from './grading-rule.service';
import { GradingScheduleService } from './grading-schedule.service';
import { LoadingComponent } from './loading/loading.component';
import { MatCardViewComponent } from './mat-card-view/mat-card-view.component';
import { RenderHtmlComponent } from './render-html/render-html.component';
import { RosterService } from './roster.service';
import { RowUiService } from './row-ui.service';
import { SafeHtmlPipe } from './safe-html.pipe';
import { AlertService } from './services/alert.service';
import { LogService } from './services/log.service';
import { SortableTableHeaderDirective } from './sortable-table/sortable-table-header.directive';
import { SortableTableComponent } from './sortable-table/sortable-table.component';
import { TextIconComponent } from './text-icon/text-icon.component';
import { DateService } from './utilities/date.service';
import { ReflectionService } from './utilities/reflection.service';
import {CourseRosterIpService} from "./course-roster-ip.service";
import {GradePostTransactionIdService} from "./services/grade-post-transaction-id.service";

const componentParsers: Array<HookParserEntry> = [
    {
        component: TextIconComponent,
        inputsWhitelist: ['tooltip', 'icon']
    }
];

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatTooltipModule,
        DynamicHooksModule.forRoot({
            globalParsers: componentParsers
        }),
        MatProgressSpinnerModule,
        MatIconModule
    ],
    declarations: [
        FilterPipe,
        ArrayFilterPipe,
        SortableTableComponent,
        SortableTableHeaderDirective,
        LoadingComponent,
        RenderHtmlComponent,
        TextIconComponent,
        SafeHtmlPipe,
        MatCardViewComponent
    ],
    exports: [
        FilterPipe,
        SortableTableComponent,
        SortableTableHeaderDirective,
        LoadingComponent,
        RenderHtmlComponent,
        TextIconComponent,
        SafeHtmlPipe,
        MatCardViewComponent,
        ArrayFilterPipe
    ],
    providers: [
        CourseService,
        CourseRosterIpService,
        RosterService,
        GradingScheduleService,
        GradingRuleService,
        GradeStatementService,
        CompareValueService,
        CourseCacheService,
        CourseChangeLogService,
        AlertService,
        ReflectionService,
        DateService,
        LogService,
        RowUiService,
        GradePostTransactionIdService
    ]
})
export class SharedModule {}
